if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)
	

	// slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
	document.querySelectorAll('.swiper-js').forEach((element,i) => {
		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
		
		element.setAttribute(`data-swiper-${i}`,"")
		
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
		
		//add custom count 
		function customcount(element){
			let countcontainerall= document.querySelectorAll(element);
			let slides = swiper.slides;
			let filteredSlides = slides.filter(function(slide) {
				return !slide.classList.contains("swiper-slide-duplicate") ;
			});
			countcontainerall.forEach((element) =>{
				let addstring =`<span class="counter">${swiper.realIndex + 1} </span>
												<span class="total-count"> /${filteredSlides.length}</span>`;
				element.innerHTML = addstring;
			});
			
		}

		// start count custom
		customcount(`[data-swiper-${i}] ${swiperConfig.customcount}`);
		swiper.on('slideChange', () => {
			// //refresh count cutom
			document.querySelectorAll(`[data-swiper-${i}] .counter`).forEach((element) =>{
				element.innerHTML = swiper.realIndex + 1;
			});
		});

	});
	
	//funcionality for accordion quad
	let content_acordion = document.querySelectorAll(".content-js");
	let imagen_acordion = document.querySelectorAll(".imagen-js");
	content_acordion.forEach((element, i) =>{
		element.addEventListener("click", (e)=>{
			document.querySelectorAll('.accordion-quad__item,.accordion-quad__group').forEach(b => b.classList.remove('active'));
			element.parentElement.classList.add("active");
			element.nextElementSibling.classList.add("active");
			imagen_acordion.forEach(img =>{
				img.classList.remove("active")
				if (element.dataset.content == img.dataset.imagen) {
					img.classList.add("active")
				}
			})
		})
		if (i === 0) element.click();
	})

// table section
const tablesResp = document.querySelectorAll('.table-js table');
if (tablesResp.length) {
	tablesResp.forEach((tablei) => {
		let tableresponsive = document.createElement('div')
		tableresponsive.classList.add('tableHold')
		tablei.parentNode.insertBefore(tableresponsive, tablei)
		tableresponsive.append(tablei)
		const ths = tablei.querySelectorAll('tr:first-child > *')
		tablei.querySelectorAll('tr + tr').forEach((row) => {
			const tds = row.querySelectorAll('td')
			let i = 0
			for (i; i < tds.length; i++) {
				tds[i].setAttribute('data-label', ths[i].textContent)
			}
		})
		const rowHeads = tablei.querySelectorAll('tr td:first-child')
		rowHeads.forEach((ele) => {
			ele.addEventListener('click', (ev) => {
				ele.closest('tr').classList.toggle('active')
			})
		})
	})
}
 // if top content is empty
	if (document.getElementById("top-content") == null) {
		document.querySelector("header").classList.add("no-top")
	};
	
	// sign up add attribute
	const sign_inputs = document.querySelectorAll(".email-signup .fields-wrap .input input");
	sign_inputs.forEach(input => {
		input.setAttribute("autocomplete", "off")
	});

	//remove id for ada
	document.querySelector(".burger-menu .tertiary-navigation").removeAttribute("id");
	document.querySelector(".burger-menu .tertiary-navigation .tertiary-navigation__list").removeAttribute("id");

})()
